/**
 * Placeholder utility functions for text content
 * Handles extraction and replacement of {{placeholder}} patterns
 */

/**
 * Extract placeholders from text (e.g., {{bride_name}}, {{venue}})
 * @param {string} text - The text containing placeholders
 * @returns {Array<string>} Array of unique placeholder names (without braces)
 */
export const extractPlaceholders = (text) => {
  if (!text || typeof text !== 'string') {
    return [];
  }

  const placeholderRegex = /\{\{([^}]+)\}\}/g;
  const placeholders = [];
  let match;

  while ((match = placeholderRegex.exec(text)) !== null) {
    const placeholderName = match[1].trim();
    if (placeholderName && !placeholders.includes(placeholderName)) {
      placeholders.push(placeholderName);
    }
  }

  return placeholders;
};

/**
 * Replace placeholders in text with values from array
 * @param {string} text - The text containing placeholders
 * @param {Array<{key: string, value: string}>} placeholdersArray - Array of placeholder key-value pairs
 * @returns {string} Text with placeholders replaced (empty string if placeholder not found)
 */
export const replacePlaceholders = (text, placeholdersArray = []) => {
  if (!text || typeof text !== 'string') {
    return text || '';
  }

  if (!Array.isArray(placeholdersArray)) {
    return text;
  }

  // Create a map for quick lookup
  const placeholderMap = {};
  placeholdersArray.forEach(item => {
    if (item && typeof item === 'object' && item.key) {
      placeholderMap[item.key] = item.value || '';
    }
  });

  let result = text;
  
  // Find all placeholders and replace them
  const placeholderRegex = /\{\{([^}]+)\}\}/g;
  result = result.replace(placeholderRegex, (match, key) => {
    const trimmedKey = key.trim();
    // Return the value if found, otherwise empty string
    return placeholderMap.hasOwnProperty(trimmedKey) ? placeholderMap[trimmedKey] : '';
  });

  return result;
};



